"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IpcBusSocket = exports.PING_TIMEOUT = void 0;
const types_1 = require("@refinitiv-data/types");
exports.PING_TIMEOUT = 60 * 1000;
class IpcBusSocket {
    constructor() {
        this.binaryType = '';
        this.pingSuccess = true;
    }
    startPing() {
        if (this.timerId) {
            return;
        }
        const onTimeout = () => {
            if (!this.pingSuccess) {
                this.timerId = void 0;
                this.close();
                if (this.onerror) {
                    this.onerror({ error: new Error('Pong timeout'), message: 'Timeout', type: 'timeout', target: this });
                }
            }
            else {
                this.pingSuccess = false;
                const pingMessage = { type: types_1.IpcBusSocketMessageType.Ping };
                this.sendRawMessage(pingMessage);
                this.timerId = setTimeout(onTimeout, exports.PING_TIMEOUT);
            }
        };
        this.timerId = setTimeout(onTimeout, exports.PING_TIMEOUT);
    }
    stopPing() {
        if (this.timerId) {
            clearTimeout(this.timerId);
            this.timerId = void 0;
        }
    }
    formatMessage(message) {
        const ipcBusSocketMessage = {
            data: message,
            type: types_1.IpcBusSocketMessageType.Data,
        };
        return ipcBusSocketMessage;
    }
    onMessage(message) {
        const serverMessage = message;
        switch (serverMessage.type) {
            case types_1.IpcBusSocketMessageType.Data:
                if (this.onmessage) {
                    this.onmessage({ data: serverMessage.data, target: this, type: 'data' });
                }
                break;
            case types_1.IpcBusSocketMessageType.Close:
                this.close();
                if (this.onclose) {
                    this.onclose({ reason: serverMessage.reason, wasClean: true, target: this, code: 1006 });
                }
                break;
            case types_1.IpcBusSocketMessageType.Init:
                if (this.onopen) {
                    this.onopen({ target: this });
                }
                break;
            case types_1.IpcBusSocketMessageType.Ping:
                const pongMessage = { type: types_1.IpcBusSocketMessageType.Pong };
                this.sendRawMessage(pongMessage);
                break;
            case types_1.IpcBusSocketMessageType.Pong:
                this.pingSuccess = true;
                break;
        }
    }
}
exports.IpcBusSocket = IpcBusSocket;
//# sourceMappingURL=data:application/json;base64,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